import React, {useMemo, useRef} from 'react';
import styled from "styled-components";
import {getCssSizeValue, getHtmlFromRedactorField} from "@/utils/utils";
import Text from "@/components/common/Text";
import useColor from "@/hooks/useColor";
import Reveal from "@/animations/Reveal";
import * as ourMission from '@/assets/lottie/nasza-misja.json'
import * as ourVision from '@/assets/lottie/nasza-wizja.json'
import useInView from "@/hooks/useInView";
import useIsDebug from "@/hooks/useIsDebug";
import {BREAKPOINTS} from "@/styles/themeSettings";
import dynamic from "next/dynamic";

const Lottie = dynamic(() => import("react-lottie"), { ssr: false });

const ANIMATION_OPTIONS = {
	OUR_MISSION: 'our-mission',
	OUR_VISION: 'our-vision'
}

const ANIMATIONS = {
	[ANIMATION_OPTIONS.OUR_MISSION]: ourMission,
	[ANIMATION_OPTIONS.OUR_VISION]: ourVision,
}

const Wrapper = styled.div`
	position: relative;
	background-color: ${({ $bgColor }) => $bgColor || 'unset'};
	min-height: 1px;
	aspect-ratio: 1;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
    padding: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};

    @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
    }

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        padding: ${getCssSizeValue(48)} ${getCssSizeValue(32)} ${getCssSizeValue(32)} ${getCssSizeValue(40)};
    }
`

const AnimationWrapper = styled.div`
	position: relative;
	display: flex;
	width: 100%;
	max-width: 50%;
	margin: 0 auto;
	aspect-ratio: 1;
`

const ColorfulSquare = ({ data, className='', ...props }) => {
	const WrapperRef= useRef()
	const color = useColor(data?.color?.color || 'indianRed')
	const header = data?.header || ''
	const desc = getHtmlFromRedactorField(data?.description || '')
	const debug = useIsDebug()
	const animation = data?.animation || ANIMATION_OPTIONS.FIRST

	const defaultOptions = useMemo(() => {
		return {
			loop: true,
			autoplay: false,
			animationData: ANIMATIONS[animation],
			rendererSettings: {
				preserveAspectRatio: 'xMidYMid slice'
			}
		}
	}, []);

	const { inView } = useInView(WrapperRef, {
		markers: debug
	})

	return (
		<Wrapper ref={WrapperRef} $bgColor={color} className={`colorful-square ${className}`} {...props}>
			<Reveal onInView>
				<Text className="header typo-borna typo-borna-121">
					{header}
				</Text>
			</Reveal>
			<AnimationWrapper>
				<Lottie options={defaultOptions} isClickToPauseDisabled ariaRole={"generic"} isPaused={!inView}  />
			</AnimationWrapper>
			<Reveal onInView>
				<Text as="div" className="typo-strawford-11" dangerouslySetInnerHTML={desc}/>
			</Reveal>
		</Wrapper>
	);
};

export default ColorfulSquare;
